import { Component, Input, OnInit } from '@angular/core';
import { ProductService } from '../../_services/product.service';
import { BundleItem } from '../../_models/bundle-item';

@Component({
  selector: 'app-bundle-items',
  templateUrl: './bundle-items.component.html',
  styleUrls: ['./bundle-items.component.scss']
})
export class BundleItemsComponent implements OnInit {
  @Input()
  private productId: number;

  public bundleItems: BundleItem[];

  constructor(public productService: ProductService) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.productService.getPackageBundles(this.productId).subscribe({
      next: (response) => {
        console.log(response);
        const bundleItem = new BundleItem();
        bundleItem.ProductId = this.productId;
        this.bundleItems = [...response, bundleItem];
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  dataChanged() {

  }

  saveItem(product: BundleItem) {
    this.productService.savePackageBundles(this.productId, product).subscribe({
      next: (response) => {
        console.log(response);
        this.loadData();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  deleteItem(product: BundleItem) {
    this.productService.deletePackageBundles(this.productId, product.Id).subscribe({
      next: (response) => {
        console.log(response);
        this.loadData();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

}
